import type { HSLColor } from "../types/colors/HSLColor"
import type { RGBColor } from "../types/colors/RGBColor"

/**
 * Converts HSL color to RGB color
 * Assumes HSL values are in range:
 * - h: 0-360 degrees
 * - s: 0-1
 * - l: 0-1
 */
export function HslToRgb(hsl: HSLColor): RGBColor {
  const { h, s, l, a } = hsl

  let r, g, b

  if (s === 0) {
    // Achromatic (gray)
    r = g = b = l
  } else {
    const hue = h / 360 // Normalize hue to 0-1
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s
    const p = 2 * l - q

    r = hueToRgb(p, q, hue + 1 / 3)
    g = hueToRgb(p, q, hue)
    b = hueToRgb(p, q, hue - 1 / 3)
  }

  return { r, g, b, a }
}

/**
 * Helper function to convert hue to RGB component
 */
function hueToRgb(p: number, q: number, t: number): number {
  if (t < 0) t += 1
  if (t > 1) t -= 1
  if (t < 1 / 6) return p + (q - p) * 6 * t
  if (t < 1 / 2) return q
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6
  return p
}
